// extracted by mini-css-extract-plugin
export default {"container":"Header__container___WzMgb","leftContainer":"Header__leftContainer___kxmcq","bulbIcon":"Header__bulbIcon___scOjP"};